import { Component, ElementRef, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormArray,
  ValidatorFn,
} from '@angular/forms';
import { fatorConversaoValidator } from '../../../shared/validators/fator-conversao.validator';
import { controleMultiploValidator } from '../../../shared/validators/controle-multiplo.validator';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { ProdutoService } from '../../../shared/services/apis/produto/produto.service';
import { CompraService } from '../../../shared/services/apis/compras/compra.service';
import { GoldProdutoService } from '../../../shared/services/apis/motor-produto-gtin/gold-produto.service';
import { GoldProduto } from '../../../shared/services/models/motor-produto-gtin/gold-produto.model';
import {
  GtinConsultaDialogComponent,
  GtinCampoSelecionavel,
  GtinConsultaDialogData,
} from './components/gtin-consulta-dialog/gtin-consulta-dialog.component';
import { LookupService } from '../../../shared/services/apis/produto/produto-lookup.service';
import { MotorFiscalLookupService } from '../../../shared/services/apis/motor-fiscal/motor-fiscal-lookup.service';
import { ConfiguracaoProdutoService } from '../../../shared/services/apis/produto/configuracao-produto.service';
import { ProdutoRequest } from '../../../shared/services/requests/produto/produto.request';
import { ProdutoVariacaoItemStruct } from '../../../shared/services/structs/produto/produto-variacao-item.struct';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { environment } from '../../../../environments/environment';
import {
  PageScrollSpyComponent,
  ScrollSpySection,
} from '../../../shared/components/page-scroll-spy/page-scroll-spy.component';
import { Masks, MaskService } from '../../../shared/services/mask.service';
import { provideNgxMask } from 'ngx-mask';
import { FooterActionComponent } from '../../../shared/components/footer-action/footer-action.component';
import { LookupItemStruct } from '../../../shared/services/structs/pessoa/lookup-item.struct';
import { UnidadeMedidaStruct } from '../../../shared/services/structs/produto/unidade-medida.struct';
import { TagListItem } from '../../../shared/services/structs/produto/tag-list-item.struct';
import { TipoProdutoEnum } from '../../../shared/enums/produto/tipo-produto.enum';
import { TipoContatoEnum } from '../../../shared/enums/pessoa/tipo-contato.enum';
import { ProdutoArquivoStruct } from '../../../shared/services/structs/produto/produto-arquivo.struct';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { ProdutoResponse } from '../../../shared/services/responses/produto/produto.response';
import { ProdutoKitImpactadoStruct } from '../../../shared/services/structs/produto/produto-kit-impactado.struct';
import { ProdutoDadosGeraisComponent } from './components/produto-dados-gerais/produto-dados-gerais.component';
import { ProdutoEstoqueComponent } from './components/produto-estoque/produto-estoque.component';
import { ProdutoPrecosComponent } from './components/produto-precos/produto-precos.component';
import { ProdutoAtributosComponent } from './components/produto-atributos/produto-atributos.component';
import { ProdutoComplementaresComponent } from './components/produto-complementares/produto-complementares.component';
import { ProdutoCustosComponent } from './components/produto-custos/produto-custos.component';
import { ProdutoKitsComponent } from './components/produto-kits/produto-kits.component';
import { ProdutoVariacoesComponent } from './components/produto-variacoes/produto-variacoes.component';
import { ProdutoProducaoComponent } from './components/produto-producao/produto-producao.component';
import { ProdutoOutrosComponent } from './components/produto-outros/produto-outros.component';
import { ProdutoComposicaoKitStruct } from '../../../shared/services/structs/produto/produto-composicao-kit.struct';
import { ConfiguracaoProduto } from '../../../shared/services/models/produto/configuracao-produto.model';
import { ProdutoPreco } from '../../../shared/services/models/produto/produto-preco.model';
import { EstoqueSaldoProduto } from '../../../shared/services/models/produto/estoque-saldo-produto.model';
import { ProdutoFornecedor } from '../../../shared/services/models/produto/produto-fornecedor.model';
import { ProdutoAtributoValor } from '../../../shared/services/models/produto/produto-atributo-valor.model';
import { ProdutoCustoHistorico } from '../../../shared/services/models/produto/produto-custo-historico.model';
import { TipoGeracaoSkuEnum } from '../../../shared/enums/produto/tipo-geracao-sku.enum';
import { ProdutoVariacaoValorStruct } from '../../../shared/services/structs/produto/produto-variacao-valor.struct';
import { GetProdutoLookupResponse } from '../../../shared/services/responses/produto/get-produto-lookup.response';
import { Embalagem } from '../../../shared/services/models/produto/embalagem.model';
import { LocalizacaoEstoque } from '../../../shared/services/models/produto/localizacao-estoque.model';
import { TipoNcmEnum } from '@shared/enums/motor-fiscal/tipo-ncm.enum';
import { ProdutoConfiguracaoCampoObrigatorioService } from '@shared/services/apis/produto/produto-configuracao-campo-obrigatorio.service';
import { CampoObrigatorioStruct } from '@shared/services/structs/financas/campo-obrigatorio.struct';
import { TelaProdutoEnum } from '@shared/enums/produto/tela-produto.enum';
import { minArrayLengthValidator } from '@shared/validators/min-array-length.validator';
import { NFeEntradaItemService } from '@shared/services/apis/repo-dfe/nfe-entrada-item.service';
import { OrigemCadastroProdutoEnum } from '@shared/enums/produto/origem-cadastro-produto.enum';
import { lerOrigemCadastroProduto } from '@shared/helpers/produto-cadastro-origem.helper';
import { ProdutoOrigemCadastroStruct } from '@shared/services/structs/produto/produto-origem-cadastro.struct';

@Component({
  selector: 'app-produto-cadastro',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatRadioModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatChipsModule,
    MatAutocompleteModule,
    HeaderComponent,
    PageScrollSpyComponent,
    FooterActionComponent,
    ProdutoDadosGeraisComponent,
    ProdutoEstoqueComponent,
    ProdutoPrecosComponent,
    ProdutoAtributosComponent,
    ProdutoComplementaresComponent,
    ProdutoCustosComponent,
    ProdutoKitsComponent,
    ProdutoVariacoesComponent,
    ProdutoProducaoComponent,
    ProdutoOutrosComponent,
  ],
  providers: [provideNgxMask()],
  templateUrl: './produto-cadastro.component.html',
  styleUrl: './produto-cadastro.component.css',
})
export class ProdutoCadastroComponent implements OnInit {
  public moduloEnum = ModuloEnum.Cadastros;
  public funcionalidadeEnum = FuncionalidadeEnum.Cadastros_Produtos;

  public form: FormGroup;
  public isEditMode: boolean = false;
  public isLoading: boolean = false;
  public isSaving: boolean = false;
  public isBuscandoGtin: boolean = false;
  public idProduto: number;
  private defaultsCarregados = false;
  private lookupsCarregados = false;
  // Origem lida da query em modo inclusão; aplicada uma única vez, depois dos defaults e dos lookups.
  private origemCadastro: { origem: OrigemCadastroProdutoEnum; idOrigem: number } | null = null;
  private origemAplicada = false;
  public idProdutoPai: number | null = null;
  public masks: Masks = MaskService.getMasks();
  public percentageMask = this.maskService.getDecimalMask2();
  public defaultCurrencyMask = this.maskService.getCurrencyMask();
  public dynamicCurrencyMask = this.maskService.getDynamicCurrencyMask();
  public quantidadeMask = this.maskService.getDynamicDecimalMask();
  public integerMask = this.maskService.getIntegerMask();

  /**
   * Máscara das quantidades de estoque do próprio produto (Locais de Estoque e, por
   * herdarem a mesma unidade, o estoque por local de cada Variação). Quando a unidade de
   * medida selecionada não é fracionada, força a entrada como número inteiro.
   */
  get estoqueQuantidadeMask(): any {
    const unidade = this.listaUnidadeMedida?.find(u => u.idUnidadeMedida === this.form?.get('idUnidadeMedida')?.value);
    return unidade?.isFracionada === false ? this.integerMask : this.quantidadeMask;
  }

  /** Unidade de medida selecionada é fracionada? Usado pelos painéis de lote/série (estoque
   * próprio do produto e de cada variação) pra decidir a máscara de quantidade (inteiro vs.
   * decimal) — item 19 do BUG#146148. */
  get isFracionadaEstoque(): boolean {
    const unidade = this.listaUnidadeMedida?.find(u => u.idUnidadeMedida === this.form?.get('idUnidadeMedida')?.value);
    return unidade?.isFracionada !== false;
  }

  public isKit: boolean = false;
  /** Algum componente do kit está com quantidade fora do múltiplo (bloqueia a gravação). */
  public multiploKitInvalido: boolean = false;
  public isVariacao: boolean = false; // Propriedade corrigida para inglês
  public isFabricado: boolean = false;
  public _tipoProdutoEnum = TipoProdutoEnum;
  public nomeProdutoPai: string | null;
  public skuProdutoPai: string | null;

  // Configuração de Produto
  public configuracaoProduto: ConfiguracaoProduto;

  // Attachments
  public anexos: ProdutoArquivoStruct[] = [];
  // Imagem de capa exibida no topo (modo edição)
  public urlImagemCapaAssinada: string | null = null;
  private urlCapaAssinadaPara: string | null = null;
  // Lookups
  public listaUnidadeMedida: UnidadeMedidaStruct[];
  public listaLinhaProduto: LookupItemStruct[];
  public listaTipoItemSped: LookupItemStruct[];
  public listaEmbalagem: Embalagem[];
  public listaCategoria: LookupItemStruct[];
  public listaMarca: LookupItemStruct[];
  public listaOrigem: LookupItemStruct[];
  public listaTipoProduto: LookupItemStruct[];
  public listaVariacao: LookupItemStruct[];
  public listaPreco: any[];
  public listaLocalizacaoEstoque: LocalizacaoEstoque[];
  public listaAtributo: LookupItemStruct[];
  public listaTag: TagListItem[];
  public listaTabelaMedida: LookupItemStruct[];

  // Seletor de insumo da Ficha de Produção: aceita Simples, Fabricado (hierarquia de fabricação)
  // e Matéria-prima. Exclui o próprio produto em edição para evitar auto-referência.
  // O model binding do ASP.NET Core para List<long> via querystring exige chaves repetidas
  // (?listIdTipoProduto=1&listIdTipoProduto=4&...), não um valor único separado por vírgula.
  public get urlProduto(): string {
    const tipos = [TipoProdutoEnum.Simples, TipoProdutoEnum.Fabricado, TipoProdutoEnum.MateriaPrima]
      .map(t => `listIdTipoProduto=${t}`).join('&');
    let url = `${environment.urlApiProduto}Lookup/listProdutoSelect?${tipos}`;
    if (this.isEditMode && this.idProduto) {
      url += `&idProdutoExcluir=${this.idProduto}`;
    }
    return url;
  }
  public urlFornecedor = `${environment.urlApiPessoa}Lookup/listPessoaSelect?idTipoContato=${TipoContatoEnum.Fornecedor}`;
  public urlNcm = `${environment.urlApiMotorFiscal}Lookup/ncm?tipoNcm=${TipoNcmEnum.SubItem}`;

  // Scroll Spy
  public sections: ScrollSpySection[] = [
    { id: 'info-basica', label: 'Dados Gerais' },
    { id: 'precos', label: 'Preços' },
    { id: 'estoque', label: 'Estoque' },
    { id: 'complementar', label: 'Dados Complementares' },
    { id: 'ficha-tecnica', label: 'Ficha Técnica' },

    { id: 'custos', label: 'Custos' },
    { id: 'outros', label: 'Outros' },
  ];

  public dadosKitsCarregados: ProdutoComposicaoKitStruct[] = [];
  public dadosEstruturaProducaoCarregados: any[] = [];
  public dadosEtapasProducaoCarregados: any[] = [];
  public dadosPrecosCarregados: ProdutoPreco[] = [];
  public dadosEstoqueCarregados: EstoqueSaldoProduto[] = [];
  public dadosFornecedoresCarregados: ProdutoFornecedor[] = [];
  public dadosVariacoesProdutoCarregados: ProdutoVariacaoItemStruct[] = [];
  public dadosVariacoesCarregados: ProdutoVariacaoValorStruct[] = [];
  public dadosCustosCarregados: ProdutoCustoHistorico[] = [];
  /** Custo médio atual do produto, do estoque (somente leitura no cadastro). */
  public custoMedioAtual: number | null = null;
  public dadosAtributosCarregados: ProdutoAtributoValor[] = [];

  // Validação de Kit Impactado
  public listProdutosKitPai: ProdutoKitImpactadoStruct[] = [];
  public precoOriginal: number | null = null;
  public precoKitAtualizado: number = 0;

  // Campos obrigatórios configuráveis (Configurações > Cadastros > Campos obrigatórios).
  // Se a configuração não carregar, o formulário mantém só as obrigatoriedades fixas.
  public camposObrigatorios: CampoObrigatorioStruct[] = [];
  private readonly validadorFornecedores = minArrayLengthValidator(1);
  // nome_tecnico (coluna no banco) -> controle do formulário que recebe Validators.required.
  // SKU com geração automática fica desabilitado e, por isso, não é exigido.
  private readonly controlePorCampoConfiguravel: Record<string, string> = {
    codigo_sku: 'codigoSku',
    gtin_ean: 'gtinEan',
    cest: 'cest',
    id_categoria: 'idCategoria',
    id_marca: 'idMarca',
    peso_bruto_kg: 'pesoBrutoKg',
    peso_liquido_kg: 'pesoLiquidoKg',
    markup_padrao: 'markupPadrao',
  };

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private produtoService: ProdutoService,
    private compraService: CompraService,
    private goldProdutoService: GoldProdutoService,
    private lookupService: LookupService,
    private motorFiscalLookupService: MotorFiscalLookupService,
    private configProdutoService: ConfiguracaoProdutoService,
    private alertService: AlertService,
    private maskService: MaskService,
    private dialog: MatDialog,
    private produtoConfiguracaoCampoObrigatorioService: ProdutoConfiguracaoCampoObrigatorioService,
    private nfeEntradaItemService: NFeEntradaItemService,
    private elementRef: ElementRef<HTMLElement>
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.carregarCamposObrigatorios();
    this.checkRoute();
    this.loadLookups();
  }

  private carregarCamposObrigatorios(): void {
    this.produtoConfiguracaoCampoObrigatorioService.getByTela(TelaProdutoEnum.Produto).subscribe({
      next: res => {
        if (res.isError) return;
        this.camposObrigatorios = res.listaTelaComCampos[0]?.listaCampos ?? [];
        this.aplicarCamposObrigatorios();
      },
      // Falha na configuração não bloqueia o cadastro: seguem só as obrigatoriedades fixas.
      error: () => { },
    });
  }

  public isObrigatorio(nomeTecnico: string): boolean {
    return this.camposObrigatorios.some(c => c.nomeTecnico === nomeTecnico && c.isObrigatorio);
  }

  private aplicarCamposObrigatorios(): void {
    Object.entries(this.controlePorCampoConfiguravel).forEach(([nomeTecnico, controle]) =>
      this.alternarValidador(this.form.get(controle), Validators.required, this.isObrigatorio(nomeTecnico)));
    // Na inclusão com SKU sequencial EAN-13 o GTIN é gerado a partir do SKU ao gravar: não é exigido no formulário.
    const geraGtin = !this.isEditMode && this.configuracaoProduto?.idTipoGeracaoSku === TipoGeracaoSkuEnum.SequencialEAN13;
    this.alternarValidador(this.form.get('gtinEan'), Validators.required, this.isObrigatorio('gtin_ean') && !geraGtin);
    this.alternarValidador(this.fornecedores, this.validadorFornecedores, this.isObrigatorio('produto_fornecedor'));
  }

  private alternarValidador(control: AbstractControl | null, validador: ValidatorFn, exigir: boolean): void {
    if (!control) return;
    if (exigir && !control.hasValidator(validador)) {
      control.addValidators(validador);
    } else if (!exigir && control.hasValidator(validador)) {
      control.removeValidators(validador);
    }
    control.updateValueAndValidity({ emitEvent: false });
  }

  /**
   * Preço na lista padrão obrigatório: a linha da lista padrão precisa ter preço maior que zero.
   * A linha é criada pelo componente de preços, por isso a checagem acontece no salvar.
   */
  private validarPrecoListaPadrao(): boolean {
    if (!this.isObrigatorio('preco_lista_padrao')) return true;

    const linhaPadrao = this.precos.controls.find(c => this.isListaPadrao(c.get('idListaPreco')?.value));
    const preco = Number(linhaPadrao?.get('precoVenda')?.value);
    if (linhaPadrao && preco > 0) return true;

    const precoControl = linhaPadrao?.get('precoVenda');
    precoControl?.setErrors({ ...(precoControl.errors ?? {}), valorMaiorQueZero: true });
    precoControl?.markAsTouched();
    this.alertService.show('Atenção', 'Informe um valor maior que zero no preço da lista de preço padrão.', AlertType.warning);
    document.getElementById('precos')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return false;
  }

  /** Rola até o primeiro campo inválido e o foca. */
  private focarPrimeiroCampoInvalido(): void {
    setTimeout(() => {
      const campo = this.elementRef.nativeElement.querySelector<HTMLElement>(
        'input.ng-invalid, textarea.ng-invalid, mat-select.ng-invalid, .produto-obrigatorio-erro');
      campo?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      campo?.focus({ preventScroll: true });
    });
  }

  private initForm(): void {
    this.form = this.fb.group(
      {
        // Dados Gerais
        isAtivo: [true],
        idTipoProduto: [{ value: TipoProdutoEnum.Simples, disabled: this.isEditMode }, Validators.required], // 1=Simples
        idTipoItemSped: [null, Validators.required], // 00 - Mercadoria para Revenda
        nome: ['', [Validators.required, Validators.maxLength(120)]],
        gtinEan: [''],
        ncm: ['', [Validators.required, (c: AbstractControl) => ((c.value ?? '').replace(/\D/g, '').length === 8 ? null : { ncmSubitem: true })]],
        idUnidadeMedida: [null, Validators.required],
        codigoSku: [''],
        idOrigemMercadoria: [null, Validators.required], // origem = id central de origem_mercadoria (Motor Fiscal); default vem do config
        cest: ['', [(c: AbstractControl) => { const d = (c.value ?? '').replace(/\D/g, ''); return (d.length === 0 || d.length === 7) ? null : { cestCompleto: true }; }]],
        descricaoComplementar: [''],

        // Controle de múltiplo (embalagem fechada). Opcionais, mas pareados quando o toggle liga:
        // quem cuida disso é o controleMultiploValidator, no grupo raiz.
        isControlaMultiplo: [false],
        idUnidadeMultiplo: [null],
        fatorMultiplo: [null],

        // Dimensões
        pesoLiquidoKg: [null, Validators.min(0)],
        pesoBrutoKg: [null, Validators.min(0)],
        volumes: [null, Validators.min(0)],
        larguraCm: [null, Validators.min(0)],
        alturaCm: [null, Validators.min(0)],
        comprimentoCm: [null, Validators.min(0)],
        diametroCm: [null, Validators.min(0)],
        idEmbalagem: [null], // Cadastro de Embalagem

        // Preços
        markupPadrao: [null],
        precos: this.fb.array([]),

        // Estoque
        isControlaEstoque: [true],
        isSobEncomenda: [false],
        diasPreparacao: [null, Validators.min(0)],
        isControlaLotes: [false],
        isControlaSeries: [false],
        localizacoesEstoque: this.fb.array([]),

        // Complementar
        idCategoria: [null],
        idMarca: [null],
        idTabelaMedida: [null], // Mentioned in User Story

        // Ficha Técnica
        atributos: this.fb.array([]),

        // Kits (Visible if Tipo=Kit)
        isPrecoKitFixo: [false],
        precoKitFixo: [null],
        composicao: this.fb.array([]),

        // Variações (Visible if Tipo=Com Variação)
        variacoes: this.fb.array([]),
        combinacoes: this.fb.array([]),

        // Produção (Visible if Tipo=Fabricado)
        isGerarOrdemProducao: [false],
        producao: this.fb.array([]), // Estrutura
        etapasProducao: this.fb.array([]), // Etapas

        // Custos
        custos: this.fb.array([]),

        // Outros
        unidadePorCaixa: [null, Validators.min(0)],
        idLinhaProduto: [null],
        garantiaTexto: [''],
        isPermitirVenda: [true],
        tags: [[]], // Select multiple

        // Tributário Adicional
        gtinTributavel: [''],
        idUnidadeTributavel: [null],
        fatorConversao: [null, Validators.min(0)],
        codigoEnquadramentoIpi: [''],
        valorIpiFixo: [null, Validators.min(0)],
        exTipi: [''],
        aliqImpostoSeletivo: [null, Validators.min(0)],
        qtdTributadaMonofasia: [null, Validators.min(0)],
        qtdTributadaRetencaoMonofasia: [null, Validators.min(0)],

        // Dados ANP / ANVISA (seção Outros). Estado de isenção derivado de codigoAnvisa === 'ISENTO'.
        idAnpEmpresa: [null],
        codigoAnvisa: [''],
        motivoIsencaoAnvisa: [''],
        valorMaximoPmc: [null],

        // Fornecedores
        fornecedores: this.fb.array([]),

        // Observações
        observacoesGerais: [''],

        // SEO
        seoLinkVideo: [''],
        seoSlug: [''],
        seoKeywords: [''],
        seoTitulo: [''],
        seoDescricao: ['', Validators.maxLength(255)],
      },
      { validators: [fatorConversaoValidator(), controleMultiploValidator()] }
    );
  }

  // Getters for FormArrays
  get precos(): FormArray {
    return this.form.get('precos') as FormArray;
  }
  get localizacoesEstoque(): FormArray {
    return this.form.get('localizacoesEstoque') as FormArray;
  }
  get atributos(): FormArray {
    return this.form.get('atributos') as FormArray;
  }
  get composicao(): FormArray {
    return this.form.get('composicao') as FormArray;
  }
  get variacoes(): FormArray {
    return this.form.get('variacoes') as FormArray;
  }
  get producao(): FormArray {
    return this.form.get('producao') as FormArray;
  }
  get etapasProducao(): FormArray {
    return this.form.get('etapasProducao') as FormArray;
  }
  get combinacoes(): FormArray {
    return this.form.get('combinacoes') as FormArray;
  }
  get fornecedores(): FormArray {
    return this.form.get('fornecedores') as FormArray;
  }
  get custos(): FormArray {
    return this.form.get('custos') as FormArray;
  }

  private checkRoute(): void {
    const paramId = this.route.snapshot.paramMap.get('idProduto');
    if (paramId) {
      const id = Number(paramId);
      if (id > 0) {
        this.idProduto = id;
        this.isEditMode = true;
      }
    } else {
      // Pré-preenchimento por origem (`origem` + `idOrigem` na query). Inválida: a tela abre em branco.
      const query = this.route.snapshot.queryParamMap;
      this.origemCadastro = lerOrigemCadastroProduto(query);
      if (!this.origemCadastro && (query.has('origem') || query.has('idOrigem'))) {
        this.alertService.show('Aviso', 'Origem do cadastro inválida. O cadastro foi aberto em branco.', AlertType.warning);
      }
      this.loadDefaults();
    }
  }

  private loadDefaults(): void {
    this.isLoading = true;
    // Usa o endpoint sem checagem de permissão (o de tela/config é restrito a quem pode
    // acessar as configurações; um usuário que só cadastra produtos não tem esse acesso,
    // mas ainda assim precisa herdar os valores padrão).
    this.configProdutoService.getLookup().subscribe({
      next: res => {
        if (!res.isError && res.configuracaoProduto) {
          const config = res.configuracaoProduto;
          this.configuracaoProduto = config;
          this.form.patchValue({
            idUnidadeMedida: config.idUnidadeMedidaPadrao,
            ncm: config.ncmPadrao,
            idOrigemMercadoria: config.idOrigemMercadoriaPadrao,
          });

          this.applySkuLogic(config.idTipoGeracaoSku);
          this.aplicarCamposObrigatorios();
        }
        this.defaultsCarregados = true;
        this.aplicarOrigemCadastro();
      },
      error: () => {
        this.defaultsCarregados = true;
        this.aplicarOrigemCadastro();
      },
    });
  }

  /**
   * Somente inclusão: roda uma única vez, quando defaults e lookups já chegaram. Sem origem só encerra
   * o carregamento; com origem busca o item e aplica seus dados por cima dos defaults.
   */
  private aplicarOrigemCadastro(): void {
    if (this.isEditMode || !this.defaultsCarregados || !this.lookupsCarregados || this.origemAplicada) return;
    this.origemAplicada = true;
    if (!this.origemCadastro) {
      this.isLoading = false;
      return;
    }

    const { origem, idOrigem } = this.origemCadastro;
    switch (origem) {
      case OrigemCadastroProdutoEnum.CompraItem:
        this.compraService.getItemAvulso(idOrigem).subscribe({
          next: res => {
            if (res.isError || !res.itemAvulso) {
              this.falharOrigemCadastro(res.errorDescription);
              return;
            }
            const dados: ProdutoOrigemCadastroStruct = {
              nome: res.itemAvulso.nome,
              observacao: res.itemAvulso.observacao ?? null,
              abreviacaoUnidade: res.itemAvulso.unidade ?? null,
              ncm: null,
            };
            this.preencherOrigemCadastro(dados);
          },
          error: () => this.falharOrigemCadastro(null),
        });
        break;
      case OrigemCadastroProdutoEnum.NFeEntradaItem:
        this.nfeEntradaItemService.obterPorId(idOrigem).subscribe({
          next: res => {
            if (res.isError || !res.item) {
              this.falharOrigemCadastro(res.errorDescription);
              return;
            }
            const dados: ProdutoOrigemCadastroStruct = {
              nome: res.item.descricao,
              observacao: null,
              abreviacaoUnidade: res.item.unidadeComercial,
              ncm: res.item.codigoNcm,
            };
            this.preencherOrigemCadastro(dados);
          },
          error: () => this.falharOrigemCadastro(null),
        });
        break;
    }
  }

  /** Os valores da origem têm precedência sobre os defaults; o que a origem não traz fica como está. */
  private preencherOrigemCadastro(dados: ProdutoOrigemCadastroStruct): void {
    this.isLoading = false;
    const sigla = (dados.abreviacaoUnidade ?? '').trim().toUpperCase();
    const unidade = sigla
      ? this.listaUnidadeMedida?.find(u => u.abreviacao?.trim().toUpperCase() === sigla)
      : undefined;

    const valores: { [campo: string]: unknown } = { nome: dados.nome };
    if (dados.observacao) valores['observacoesGerais'] = dados.observacao;
    if (dados.ncm) valores['ncm'] = dados.ncm;
    // Origem com unidade: encontrada entra no lugar do padrão; não encontrada deixa o campo vazio para escolha.
    if (sigla) valores['idUnidadeMedida'] = unidade?.idUnidadeMedida ?? null;
    this.form.patchValue(valores);

    if (sigla && !unidade) {
      this.alertService.show('Aviso', `A unidade ${sigla} não foi encontrada. Selecione a unidade do produto.`, AlertType.warning);
    }
  }

  private falharOrigemCadastro(errorDescription: string | null | undefined): void {
    this.isLoading = false;
    this.alertService.show('Aviso', errorDescription || 'Não foi possível carregar o item de origem.', AlertType.warning);
  }

  private applySkuLogic(idTipoGeracao: number): void {
    const skuControl = this.form.get('codigoSku');
    if (idTipoGeracao === TipoGeracaoSkuEnum.Manual) {
      skuControl?.enable();
    } else {
      skuControl?.disable();
      if (!this.isEditMode && !skuControl?.value) {
        skuControl?.setValue(null);
      }
    }
  }

  private loadData(): void {
    this.isLoading = true;
    this.produtoService.getById(this.idProduto).subscribe({
      next: (res: ProdutoResponse) => {
        this.isLoading = false;
        if (res.isError) {
          this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
          return;
        }

        if (res.produto) {
          this.form.patchValue(res.produto);
          this.idProdutoPai = res.produto.idProdutoPai;
          this.onTipoProdutoChange(res.produto.idTipoProduto);
        }
        this.nomeProdutoPai = res.nomeProdutoPai;
        this.skuProdutoPai = res.skuProdutoPai;
        if (res.precos) {
          this.dadosPrecosCarregados = res.precos;
          // Kit com preço fixo: "Preço de venda no kit" não é persistido à parte — ele só
          // serve de base para o rateio. Ao reabrir, reconstituímos a partir do valor já
          // salvo na Lista de Preço padrão (que reflete o preço final do kit).
          if (this.form.get('isPrecoKitFixo')?.value) {
            const precoPadrao = res.precos.find(
              p => this.listaPreco?.find(l => l.id === p.idListaPreco)?.listaPreco?.isPadrao
            );
            if (precoPadrao) {
              this.form.get('precoKitFixo')?.setValue(precoPadrao.precoVenda);
            }
          }
        }
        if (res.localizacoesEstoque) this.dadosEstoqueCarregados = res.localizacoesEstoque;
        if (res.fornecedores) this.dadosFornecedoresCarregados = res.fornecedores;
        if (res.arquivos) this.anexos = res.arquivos;
        if (res.urlImagemCapa) {
          this.urlImagemCapaAssinada = res.urlImagemCapa;
          this.urlCapaAssinadaPara = this.anexos.find(a => a.isCapa)?.urlArquivo ?? null;
        } else {
          this.atualizarImagemCapa();
        }
        if (res.atributos) this.dadosAtributosCarregados = res.atributos;
        if (res.composicao) this.dadosKitsCarregados = res.composicao;
        if (res.listaVariacaoProduto) this.dadosVariacoesProdutoCarregados = res.listaVariacaoProduto;
        if (res.listVariacoes) this.dadosVariacoesCarregados = res.listVariacoes;
        if (res.producao) this.dadosEstruturaProducaoCarregados = res.producao;
        if (res.etapasProducao) this.dadosEtapasProducaoCarregados = res.etapasProducao;
        if (res.custos) this.dadosCustosCarregados = res.custos;
      this.custoMedioAtual = res.custoMedioAtual;
        if (res.tags && res.tags.length > 0) {
          this.form.get('tags')?.setValue(res.tags);
        }

        // Capture impacted kits list
        this.listProdutosKitPai = res.listProdutosKitPai || [];
      },
      error: err => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Não foi possível carregar o produto.', AlertType.error);
      },
    });
  }

  public onAnexosChange(anexos: ProdutoArquivoStruct[]): void {
    this.anexos = anexos;
    this.atualizarImagemCapa();
  }

  private atualizarImagemCapa(): void {
    const capa = this.anexos.find(a => a.isCapa);
    if (!capa) {
      this.urlImagemCapaAssinada = null;
      this.urlCapaAssinadaPara = null;
      return;
    }
    // Arquivo novo tem base64 local (preview via getter); só busca signed URL para arquivo já armazenado
    if (capa.base64 || !capa.urlArquivo) return;
    if (capa.urlArquivo === this.urlCapaAssinadaPara) return;

    const urlCaminho = capa.urlArquivo;
    this.produtoService.getArquivo(urlCaminho).subscribe({
      next: res => {
        if (res.isError) return;
        this.urlImagemCapaAssinada = res.urlArquivo;
        this.urlCapaAssinadaPara = urlCaminho;
      },
      error: () => {
        // Miniatura é cosmética: falha não pode travar a tela
      },
    });
  }

  get imagemCapaSrc(): string | null {
    const capa = this.anexos.find(a => a.isCapa);
    if (!capa) return null;
    if (capa.base64) {
      let ext = (capa.extensaoArquivo || '').replace('.', '').toLowerCase() || 'png';
      if (ext === 'svg') ext = 'svg+xml';
      return `data:image/${ext};base64,${capa.base64}`;
    }
    return capa.urlArquivo === this.urlCapaAssinadaPara ? this.urlImagemCapaAssinada : null;
  }

  get nomeProdutoTitulo(): string {
    return this.form.get('nome')?.value || 'Cadastro de Produto';
  }

  private loadLookups(): void {
    // Tipo de Item SPED e Origem da Mercadoria são obtidos de db_motor_fiscal via API MotorFiscal.
    this.motorFiscalLookupService.getLookup().subscribe({
      next: (res) => {
        if (!res.isError) {
          this.listaTipoItemSped = res.listaTipoItemSped;
          this.listaOrigem = res.listaOrigemMercadoria;
        }
      },
    });

    this.lookupService.getLookup().subscribe({
      next: (res: GetProdutoLookupResponse) => {
        if (!res.isError) {
          this.listaUnidadeMedida = res.listaUnidadeMedida;
          this.listaLinhaProduto = res.listaLinhaProduto;
          this.listaEmbalagem = res.listaEmbalagem;
          this.listaCategoria = res.listaCategoria;
          this.listaMarca = res.listaMarca;
          this.listaTipoProduto = res.listaTipoProduto;
          this.listaVariacao = res.listaVariacao;
          this.listaPreco = res.listaPreco.map(item => ({
            id: item.listaPreco.idListaPreco,
            descricao: item.listaPreco.descricao,
            ...item,
          }));
          this.listaLocalizacaoEstoque = res.listaLocalizacaoEstoque;
          this.listaAtributo = res.listaAtributo;
          this.listaTag = res.listaTag;
          // this.listaTabelaMedida = res.listaTabelaMedida;

          this.checkDefaultPriceList();
          if (this.idProduto) {
            this.loadData();
          }
        }
        this.lookupsCarregados = true;
        this.aplicarOrigemCadastro();
      },
      error: () => {
        this.lookupsCarregados = true;
        this.aplicarOrigemCadastro();
      },
    });
  }

  private checkDefaultPriceList(): void {
    if (!this.listaPreco || this.listaPreco.length === 0) return;

    const currentIds = this.precos.getRawValue().map((p: any) => p.idListaPreco);

    // Adicionar lista padrão
    const defaultList = this.listaPreco.find(l => l.listaPreco?.isPadrao);

    const novosPrecos: any[] = [];

    if (defaultList && !currentIds.includes(defaultList.id)) {
      novosPrecos.push({
        idProdutoPreco: 0,
        idListaPreco: defaultList.id,
        precoVenda: 0,
        metodoAjuste: defaultList.metodoAjuste,
        acaoAjuste: defaultList.acaoAjuste,
        unidadeAjuste: defaultList.unidadeAjuste,
      });
      currentIds.push(defaultList.id);
    }

    // Adicionar listas com seleção automática de produtos
    const listasAutomaticas = this.listaPreco.filter(l => l.listaPreco?.isSelecaoProdutosAutomatica);
    listasAutomaticas.forEach(lista => {
      if (!currentIds.includes(lista.id)) {
        novosPrecos.push({
          idProdutoPreco: 0,
          idListaPreco: lista.id,
          precoVenda: 0,
          metodoAjuste: lista.metodoAjuste,
          acaoAjuste: lista.acaoAjuste,
          unidadeAjuste: lista.unidadeAjuste,
        });
        currentIds.push(lista.id);
      }
    });

    if (novosPrecos.length > 0) {
      // Se já houver itens em dadosPrecosCarregados, concatena para manter as outras rows caso existam
      this.dadosPrecosCarregados = [...(this.dadosPrecosCarregados || []), ...novosPrecos];
    }
  }

  /** Tipo de rastreio ativo (lote OU série; exclusivos). */
  private get tipoRastreioAtivo(): 'lote' | 'serie' | null {
    if (this.form.get('isControlaLotes')?.value === true) return 'lote';
    if (this.form.get('isControlaSeries')?.value === true) return 'serie';
    return null;
  }

  private localEstoqueCompleto(loc: any, tipo: 'lote' | 'serie'): boolean {
    const saldo = Number(loc.saldoFisico) || 0;
    if (saldo <= 0) return true;
    if (tipo === 'lote') {
      const lotes: any[] = loc.lotes ?? [];
      const soma = lotes.reduce((s, l) => s + (Number(l.quantidade) || 0), 0);
      return lotes.length > 0 && Math.abs(soma - saldo) < 0.0001 && lotes.every(l => (l.codigoLote || '').trim());
    }
    const series: any[] = loc.series ?? [];
    return series.length === Math.round(saldo) && series.every(s => (s.codigoSerie || '').trim());
  }

  /**
   * Valida (só na inclusão) que, controlando lote/série, todo local com saldo informado
   * tenha os lotes/séries completos. Bloqueia e conduz o usuário se faltar. Retorna true se OK.
   */
  private validarEstoqueInicialLoteSerie(): boolean {
    const tipo = this.tipoRastreioAtivo;
    if (this.isEditMode || !tipo) return true;

    if (this.isVariacao) {
      const combinacaoPendente = this.combinacoes.getRawValue().some((c: any) =>
        (c.estoque ?? []).some((loc: any) => !this.localEstoqueCompleto(loc, tipo))
      );
      if (combinacaoPendente) {
        this.alertService.show(
          'Atenção',
          `Há variações com ${tipo === 'serie' ? 'séries' : 'lotes'} pendentes. Abra o estoque das variações marcadas como "Estoque incompleto" e informe os dados até bater com a quantidade.`,
          AlertType.warning
        );
        document.getElementById('variacoes')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return false;
      }
      return true;
    }

    const localPendente = this.localizacoesEstoque.getRawValue().some((loc: any) => !this.localEstoqueCompleto(loc, tipo));
    if (localPendente) {
      this.alertService.show(
        'Atenção',
        `Informe ${tipo === 'serie' ? 'as séries' : 'os lotes'} do estoque inicial até bater com a quantidade atual de cada local.`,
        AlertType.warning
      );
      document.getElementById('estoque')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return false;
    }
    return true;
  }

  /**
   * Kit não tem múltiplo próprio; nos demais tipos vale o que o toggle da aba Outros diz.
   */
  public get isControleMultiploAtivo(): boolean {
    return !this.isKit && this.form.get('isControlaMultiplo')?.value === true;
  }

  /**
   * Recebe do app-produto-kits se há componente com quantidade fora do múltiplo configurado.
   */
  public onMultiploKitInvalido(invalido: boolean): void {
    this.multiploKitInvalido = invalido;
  }

  public salvar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.alertService.show('Atenção', 'Há campos obrigatórios não preenchidos ou inválidos. Verifique os campos destacados.', AlertType.warning);
      this.focarPrimeiroCampoInvalido();
      return;
    }

    if (!this.validarPrecoListaPadrao()) return;

    // Kit com componente fora do múltiplo não grava — leva o usuário até o ponto do erro.
    if (this.isKit && this.multiploKitInvalido) {
      this.alertService.show(
        'Atenção',
        'Há componentes com quantidade fora do múltiplo configurado no cadastro. Ajuste as quantidades para gravar o kit.',
        AlertType.warning
      );
      document.getElementById('kits')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    // Balanço inicial: lote/série obrigatórios e batendo com o estoque atual (só inclusão).
    if (!this.validarEstoqueInicialLoteSerie()) return;

    // Check for price change impact on Kits
    if (this.listProdutosKitPai.length > 0 && this.precoOriginal !== null) {
      const defaultList = this.listaPreco?.find(l => l.listaPreco?.isPadrao);
      if (defaultList) {
        const currentPriceCtrl = this.precos.controls.find(
          (ctrl: any) => ctrl.get('idListaPreco')?.value === defaultList.id
        );
        const currentPrice = currentPriceCtrl?.get('precoVenda')?.value;

        if (currentPrice !== this.precoOriginal) {
          const dialogRef = this.dialog.open(ConfirmModalComponent, {
            data: {
              title: 'Atenção',
              innerHtml: `
                                <p> Ao alterar o preço desse produto, os seguintes kits terão seus preços recalculados:</p>
                                <ul style="margin: 16px 0; padding-left: 24px;">
                                    ${this.listProdutosKitPai.map(k => `<li style="margin: 4px 0;">${k.nomeProdutoKit}</li>`).join('')}
                                </ul>
                                <p>Deseja continuar?</p>
                            `,
              buttonConfirm: 'Confirmar',
              buttonClose: 'Cancelar',
            },
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result && result?.confirm) {
              this.processSave();
            }
          });
          return;
        }
      }
    }

    this.processSave();
  }

  private processSave(): void {
    this.isSaving = true;

    const request: ProdutoRequest = {
      idProdutoPai: null,
      idTipoProduto: this.form.get('idTipoProduto')?.value,
      idTipoItemSped: this.form.get('idTipoItemSped')?.value,
      nome: this.form.get('nome')?.value,
      gtinEan: this.form.get('gtinEan')?.value,
      ncm: this.form.get('ncm')?.value,
      idUnidadeMedida: this.form.get('idUnidadeMedida')?.value,
      codigoSku: this.form.get('codigoSku')?.value || null,
      idOrigemMercadoria: this.form.get('idOrigemMercadoria')?.value,
      cest: this.form.get('cest')?.value,
      descricaoComplementar: this.form.get('descricaoComplementar')?.value,
      // Kit não tem múltiplo próprio e, com o toggle desligado, o par vai nulo — o backend
      // normaliza de novo, mas não vale mandar dado pendurado.
      isControlaMultiplo: this.isControleMultiploAtivo,
      idUnidadeMultiplo: this.isControleMultiploAtivo ? this.form.get('idUnidadeMultiplo')?.value : null,
      fatorMultiplo: this.isControleMultiploAtivo ? this.form.get('fatorMultiplo')?.value : null,
      pesoLiquidoKg: this.form.get('pesoLiquidoKg')?.value,
      pesoBrutoKg: this.form.get('pesoBrutoKg')?.value,
      volumes: this.form.get('volumes')?.value,
      larguraCm: this.form.get('larguraCm')?.value,
      alturaCm: this.form.get('alturaCm')?.value,
      comprimentoCm: this.form.get('comprimentoCm')?.value,
      diametroCm: this.form.get('diametroCm')?.value,
      idEmbalagem: this.form.get('idEmbalagem')?.value,
      unidadePorCaixa: this.form.get('unidadePorCaixa')?.value,
      markupPadrao: this.form.get('markupPadrao')?.value,
      isControlaEstoque: this.form.get('isControlaEstoque')?.value,
      isSobEncomenda: this.form.get('isSobEncomenda')?.value,
      diasPreparacao: this.form.get('diasPreparacao')?.value,
      isControlaLotes: this.form.get('isControlaLotes')?.value,
      isControlaSeries: this.form.get('isControlaSeries')?.value,
      idCategoria: this.form.get('idCategoria')?.value,
      idMarca: this.form.get('idMarca')?.value,
      isPrecoKitFixo: this.form.get('isPrecoKitFixo')?.value,
      precoKitFixo: this.form.get('precoKitFixo')?.value,
      isGerarOrdemProducao: this.form.get('isGerarOrdemProducao')?.value,
      idLinhaProduto: this.form.get('idLinhaProduto')?.value,
      garantiaTexto: this.form.get('garantiaTexto')?.value,
      isPermitirVenda: this.form.get('isPermitirVenda')?.value,
      tags: this.form.get('tags')?.value || [],
      gtinTributavel: this.form.get('gtinTributavel')?.value,
      idUnidadeTributavel: this.form.get('idUnidadeTributavel')?.value,
      fatorConversao: this.form.get('fatorConversao')?.value,
      codigoEnquadramentoIpi: this.form.get('codigoEnquadramentoIpi')?.value,
      valorIpiFixo: this.form.get('valorIpiFixo')?.value,
      exTipi: this.form.get('exTipi')?.value,
      aliqImpostoSeletivo: this.form.get('aliqImpostoSeletivo')?.value,
      qtdTributadaMonofasia: this.form.get('qtdTributadaMonofasia')?.value,
      qtdTributadaRetencaoMonofasia: this.form.get('qtdTributadaRetencaoMonofasia')?.value,
      // Dados ANP / ANVISA. codigoAnvisa pode estar disabled (isento) → getRawValue().
      idAnpEmpresa: this.form.get('idAnpEmpresa')?.value ?? null,
      codigoAnvisa: this.form.getRawValue().codigoAnvisa || null,
      motivoIsencaoAnvisa: this.form.get('motivoIsencaoAnvisa')?.value || null,
      valorMaximoPmc: this.form.get('valorMaximoPmc')?.value ?? null,
      observacoesGerais: this.form.get('observacoesGerais')?.value,
      seoLinkVideo: this.form.get('seoLinkVideo')?.value,
      seoSlug: this.form.get('seoSlug')?.value,
      seoKeywords: this.form.get('seoKeywords')?.value,
      seoTitulo: this.form.get('seoTitulo')?.value,
      seoDescricao: this.form.get('seoDescricao')?.value,
      isAtivo: this.form.get('isAtivo')?.value,

      precos: this.precos
        .getRawValue()
        .filter((p: any) => {
          const lista = this.listaPreco?.find(l => l.id === p.idListaPreco);
          // Lista padrão é seleção automática, mas o preço é Manual e serve de base
          // para o cálculo de todas as outras — precisa sempre ser persistida.
          return lista?.listaPreco?.isPadrao || !lista?.listaPreco?.isSelecaoProdutosAutomatica;
        })
        .map((p: any) => ({
          idListaPreco: p.idListaPreco,
          precoVenda: p.precoVenda,
          idProdutoPreco: p.idProdutoPreco,
        })),
      localizacoesEstoque: this.localizacoesEstoque.getRawValue().map((l: any) => ({
        idLocalizacaoEstoque: l.idLocalizacaoEstoque,
        saldoFisico: l.saldoFisico,
        estoqueMinimo: l.estoqueMinimo,
        estoqueMaximo: l.estoqueMaximo,
        idEstoqueSaldoProduto: l.idEstoqueSaldoProduto,
        lotes: l.lotes ?? [],
        series: l.series ?? [],
      })),
      fornecedores: this.fornecedores.getRawValue().map((f: any) => ({
        idFornecedor: f.idFornecedor,
        codigoNoFornecedor: f.codigoNoFornecedor,
        isPrincipal: f.isPrincipal,
      })),
      atributos: this.atributos.getRawValue().map((a: any) => ({
        idAtributo: a.idAtributo,
        valor: a.valor,
      })),

      arquivos: this.anexos,

      composicao: this.composicao.getRawValue().map((c: any) => ({
        idProdutoFilho: c.idProdutoFilho,
        quantidade: c.quantidade,
        idProdutoComposicaoKit: c.idProdutoComposicaoKit,
      })),
      producao: this.producao.getRawValue().map((p: any) => ({
        idProdutoInsumo: p.idProdutoInsumo,
        idProdutoFabricado: p.idProdutoFabricado,
        quantidade: p.quantidade,
        idUnidadeConsumo: p.idUnidadeConsumo,
      })),
      etapasProducao: this.etapasProducao.getRawValue().map((e: any, index: number) => ({
        idProdutoEtapaProducao: e.idProdutoEtapaProducao,
        idProdutoFabricado: e.idProdutoFabricado,
        descricao: e.descricao,
        ordem: index + 1,
      })),
      custos: this.custos.getRawValue().map((c: any) => ({
        idProdutoCustoHistorico: c.idProdutoCustoHistorico,
        dataVigencia: this.converterDateParaDataApi(c.dataVigencia),
        precoCusto: c.precoCusto,
        impostosRecuperaveis: c.impostosRecuperaveis,
      })),
      variacoes: [],
    };

    if (this.isVariacao) {
      // idListaPreco real da lista padrão (o backend resolve a lista padrão por isPadrao,
      // não por id — um valor fixo aqui descartava o preço sempre que o id real da lista
      // padrão da empresa não fosse 1).
      const idListaPrecoPadrao = this.listaPreco?.find(l => l.listaPreco?.isPadrao)?.id;
      request.variacoes = this.combinacoes.getRawValue().map((c: any) => ({
        idProduto: c.idProduto,
        nomeVariavel: c.nomeVariavel,
        codigoSku: c.codigoSku || null,
        gtinEan: c.gtinEan,
        // Lista padrão sempre vai preenchida (mesmo 0,00) — omitir por preço falsy (0) fazia
        // o preço da variação nunca ser salvo/atualizado quando o valor era exatamente zero.
        precos: idListaPrecoPadrao ? [{ idListaPreco: idListaPrecoPadrao, precoVenda: c.preco ?? 0 }] : [],
        estoque: c.estoque,
        imagem: null,
        listProdutoVariacaoValor: c.listProdutoVariacaoValor,
      }));
    }

    const action$ = this.isEditMode
      ? this.produtoService.put(this.idProduto, request)
      : this.produtoService.post(request);

    action$.subscribe({
      next: res => {
        this.isSaving = false;
        if (res.isError) {
          this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
          return;
        }
        this.alertService.show('Sucesso', 'Produto salvo com sucesso!', AlertType.success);
        this.router.navigate(['/cadastros/produtos']);
      },
      error: err => {
        this.isSaving = false;
        const mensagem = err?.message || 'Ocorreu um erro ao salvar o produto.';
        this.alertService.show('Erro', mensagem, AlertType.error);
      },
    });
  }
  // ==================== LISTENERS PARA EVENTOS DOS COMPONENTES FILHOS ====================

  /**
   * Consulta os dados consolidados (Gold) do produto pelo GTIN digitado e,
   * mediante confirmação do usuário, preenche o formulário.
   */
  public onBuscarGtin(): void {
    const gtin: string = (this.form.get('gtinEan')?.value || '').toString().trim();

    if (!gtin) {
      this.alertService.show('Aviso', 'Informe o GTIN antes de buscar.', AlertType.warning);
      return;
    }

    this.isBuscandoGtin = true;
    this.goldProdutoService.getByGtin(gtin).subscribe({
      next: res => {
        this.isBuscandoGtin = false;

        if (res.isError || !res.goldProduto) {
          this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
          return;
        }

        const dialogRef = this.dialog.open(GtinConsultaDialogComponent, {
          data: this.montarDadosDialogGtin(res.goldProduto),
          width: '620px',
        });

        dialogRef.afterClosed().subscribe((camposSelecionados: GtinCampoSelecionavel[] | null) => {
          if (camposSelecionados && camposSelecionados.length) {
            this.aplicarCamposGtin(camposSelecionados);
            this.alertService.show('Sucesso', 'Dados aplicados a partir do GTIN.', AlertType.success);
          }
        });
      },
      error: () => {
        this.isBuscandoGtin = false;
        this.alertService.show('Erro', 'Erro ao consultar o produto pelo GTIN.', AlertType.error);
      },
    });
  }

  /**
   * Monta a lista de informações selecionáveis do dialog a partir dos dados canônicos.
   * Só inclui os campos que possuem valor. Todos vêm marcados por padrão.
   * Unidade e Origem só entram como selecionáveis quando casam com um item cadastrado
   * (a unidade pela abreviação/descrição; a origem pelo id e, como fallback, pelo código).
   */
  private montarDadosDialogGtin(gold: GoldProduto): GtinConsultaDialogData {
    const campos: GtinCampoSelecionavel[] = [];

    if (gold.descricaoCanonica) {
      campos.push({ chave: 'nome', rotulo: 'Descrição', valor: gold.descricaoCanonica, textoExibicao: gold.descricaoCanonica, selecionado: true, habilitado: true });
    }
    if (gold.ncmCanonico) {
      campos.push({ chave: 'ncm', rotulo: 'NCM', valor: gold.ncmCanonico, textoExibicao: gold.ncmCanonico, selecionado: true, habilitado: true });
    }
    if (gold.cestCanonico) {
      campos.push({ chave: 'cest', rotulo: 'CEST', valor: gold.cestCanonico, textoExibicao: gold.cestCanonico, selecionado: true, habilitado: true });
    }

    // Unidade e Unidade Tributável: usam a mesma unidade canônica retornada pelo GTIN.
    // Se não houver unidade cadastrada correspondente, o campo é exibido desabilitado com aviso.
    if (gold.unidadeCanonica) {
      const alvo = gold.unidadeCanonica.trim().toLowerCase();
      const unidade = this.listaUnidadeMedida?.find(
        u => u.abreviacao?.trim().toLowerCase() === alvo || u.descricao?.trim().toLowerCase() === alvo
      );

      campos.push(this.montarCampoUnidade('idUnidadeMedida', 'Unidade', gold.unidadeCanonica, unidade));
      campos.push(this.montarCampoUnidade('idUnidadeTributavel', 'Unidade Tributável', gold.unidadeCanonica, unidade));
    }

    // Origem: o gold retorna o CÓDIGO FISCAL (0-8), não o id interno. Por isso o match é pelo
    // `codigo` do lookup; o valor aplicado no formulário é o `id` interno correspondente.
    if (gold.origemMercadoriaCanonica !== null && gold.origemMercadoriaCanonica !== undefined) {
      const origem = this.listaOrigem?.find(
        o => o.codigo != null && String(o.codigo) === String(gold.origemMercadoriaCanonica)
      );
      if (origem) {
        campos.push({ chave: 'idOrigemMercadoria', rotulo: 'Origem', valor: origem.id, textoExibicao: origem.descricao, selecionado: true, habilitado: true });
      }
    }

    if (gold.gtinTributavelCanonico) {
      campos.push({ chave: 'gtinTributavel', rotulo: 'GTIN Tributável', valor: gold.gtinTributavelCanonico, textoExibicao: gold.gtinTributavelCanonico, selecionado: true, habilitado: true });
    }

    return { gtin: gold.gtin, campos };
  }

  /**
   * Monta um campo de unidade (comum ou tributável). Quando a unidade retornada não está
   * cadastrada no sistema, o campo fica desabilitado e informa o usuário.
   */
  private montarCampoUnidade(
    chave: string,
    rotulo: string,
    unidadeCanonica: string,
    unidade: UnidadeMedidaStruct | undefined
  ): GtinCampoSelecionavel {
    if (unidade) {
      return { chave, rotulo, valor: unidade.idUnidadeMedida, textoExibicao: unidade.descricao, selecionado: true, habilitado: true };
    }

    return {
      chave,
      rotulo,
      valor: null,
      textoExibicao: unidadeCanonica,
      selecionado: false,
      habilitado: false,
      aviso: 'Você não possui esta unidade cadastrada no sistema, portanto não é possível selecioná-la.',
    };
  }

  /**
   * Aplica ao formulário apenas os campos selecionados pelo usuário no dialog.
   */
  private aplicarCamposGtin(campos: GtinCampoSelecionavel[]): void {
    const patch: { [chave: string]: any } = {};
    campos.forEach(c => (patch[c.chave] = c.valor));
    this.form.patchValue(patch);
  }

  /**
   * Listener para atualização do tipo de produto
   */
  public onTipoProdutoChange(tipo: number): void {
    this.isKit = tipo === TipoProdutoEnum.Kit;
    this.isVariacao = tipo === TipoProdutoEnum.ComVariacao;
    this.isFabricado = tipo === TipoProdutoEnum.Fabricado;

    // Limpar seções que não são mais aplicáveis ao novo tipo
    // Limpar composição do Kit se não for mais Kit
    if (tipo !== TipoProdutoEnum.Kit) {
      this.composicao.clear();
      this.multiploKitInvalido = false;
    }

    // Kit não possui múltiplo próprio — ele apenas consome o dos componentes. O bloco some da tela,
    // então o dado também precisa sair do form para não ser gravado escondido.
    if (tipo === TipoProdutoEnum.Kit) {
      this.form.patchValue({ isControlaMultiplo: false, idUnidadeMultiplo: null, fatorMultiplo: null });
    }

    // Limpar variações e combinações se não for mais Com Variação
    if (tipo !== TipoProdutoEnum.ComVariacao) {
      this.variacoes.clear();
      this.combinacoes.clear();
    }

    // Limpar produção e etapas se não for mais Fabricado
    if (tipo !== TipoProdutoEnum.Fabricado) {
      this.producao.clear();
      this.etapasProducao.clear();
    }

    // Limpar estoque se for Kit ou Variação (que não controlam estoque próprio)
    if (tipo === TipoProdutoEnum.Kit || tipo === TipoProdutoEnum.ComVariacao) {
      this.localizacoesEstoque.clear();
    }

    this.updateScrollSpySections(tipo);
  }

  /**
   * Listener para atualização de preço do kit
   */
  onPrecoKitAtualizado(precoTotal: number): void {
    this.precoKitAtualizado = precoTotal;
    const tabelaPadrao = this.precos.controls.find(c => this.isListaPadrao(c.get('idListaPreco')?.value));
    if (tabelaPadrao) {
      tabelaPadrao.get('precoVenda')?.setValue(precoTotal);
    }
  }

  /**
   * Listener para atualização de peso do kit
   */
  onPesoKitAtualizado({ pesoBruto, pesoLiquido }: { pesoBruto: number; pesoLiquido: number }): void {
    this.form.get('pesoBrutoKg')?.setValue(pesoBruto);
    this.form.get('pesoLiquidoKg')?.setValue(pesoLiquido);
  }

  /**
   * Listener para atualização de custo de produção
   */
  onCustoProducaoAtualizado(custoTotal: number): void {
    // Verifica se já existe uma entrada pendente (sem ID) criada anteriormente
    const custos = this.custos.controls;
    const index = custos.findIndex(c => !c.get('idProdutoCustoHistorico')?.value);

    if (index !== -1) {
      // Atualiza a entrada existente
      const custoGroup = this.custos.at(index) as FormGroup;
      custoGroup.patchValue({
        dataVigencia: new Date(),
        precoCusto: custoTotal,
      });
      this.alertService.show('Sucesso', 'Custo do produto atualizado!', AlertType.success);
    } else {
      // Cria nova entrada no histórico de custos
      this.addCustoRow({
        idProdutoCustoHistorico: null,
        dataVigencia: new Date(),
        precoCusto: custoTotal,
        impostosRecuperaveis: 0,
      });
      this.alertService.show('Sucesso', 'Custo do produto adicionado ao histórico!', AlertType.success);
    }
  }

  /**
   * Listener para identificação de preço padrão
   */
  onPrecoPadraoIdentificado(preco: number): void {
    this.precoOriginal = preco;
  }

  public cancelar(): void {
    this.router.navigate(['/cadastros/produtos']);
  }

  // ==================== METODOS AUXILIARES ====================

  public isListaPadrao(id: number): boolean {
    const item = this.listaPreco?.find(l => l.id === id);
    return item?.listaPreco?.isPadrao || false;
  }


  /** Envia o dia da vigência como "yyyy-MM-dd" (DateOnly na API), sem efeito de fuso. */
  private converterDateParaDataApi(data: Date): string {
    const valor = new Date(data);
    const mes = `${valor.getMonth() + 1}`.padStart(2, '0');
    const dia = `${valor.getDate()}`.padStart(2, '0');
    return `${valor.getFullYear()}-${mes}-${dia}`;
  }

  addCustoRow(data?: any): void {
    const group = this.fb.group({
      idProdutoCustoHistorico: [data?.idProdutoCustoHistorico],
      dataVigencia: [data?.dataVigencia],
      precoCusto: [data?.precoCusto],
      impostosRecuperaveis: [data?.impostosRecuperaveis],
      idNFeEntrada: [data?.idNFeEntrada],
    });
    this.custos.push(group);
  }

  private updateScrollSpySections(tipo: number): void {
    this.sections = [{ id: 'info-basica', label: 'Dados Gerais' }];

    if (tipo === TipoProdutoEnum.Kit) {
      this.sections.push({ id: 'kits', label: 'Composição do Kit' });
    }

    this.sections.push({ id: 'precos', label: 'Preços' });

    if (tipo !== TipoProdutoEnum.Kit) {
      this.sections.push({ id: 'estoque', label: 'Estoque' });
    }

    this.sections.push(
      { id: 'complementar', label: 'Dados Complementares' },
      { id: 'ficha-tecnica', label: 'Ficha Técnica' }
    );

    if (tipo === TipoProdutoEnum.ComVariacao) {
      this.sections.push({ id: 'variacoes', label: 'Variações' });
    } else if (tipo === TipoProdutoEnum.Fabricado) {
      this.sections.push({ id: 'producao', label: 'Produção' });
    }

    if (tipo !== TipoProdutoEnum.ComVariacao) {
      this.sections.push({ id: 'custos', label: 'Custos' });
    }

    this.sections.push({ id: 'outros', label: 'Outros' });
  }
}
